import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { Scrollbars } from 'react-custom-scrollbars';
import { Modal, Form, Checkbox, message } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { DragWrap } from './DragStyle';
import { updateUserDataConfig, saveUserDataConfig, getUserDataConfig } from '../../../Api/Services/CommonApiService';
import { Button } from '../../../components/buttons/buttons';


const Popup = ({ customopen, setCustomopen, checkboxValues, configId, getColumnConfig, pageName }) => {
    const [form] = Form.useForm();
    const [checkbox, setCheckbox] = useState()
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const handleClose = () => {
        setCustomopen(false);
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        const hasChecked = checkbox?.some(item => item.isChecked);
        if (!hasChecked) {
            message.warning("Please select at least one column");
            return;
        }
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const payload =
        {
            page: pageName,
            config: checkbox
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (configId !== undefined) {
                const response = await updateUserDataConfig(payload, configId)
                if (response.status === 200) {
                    message.success("Columns updated")
                    getColumnConfig()
                    setCustomopen(false);
                }
            }
            else {
                const response = await saveUserDataConfig(payload)
                if (response.status === 201) {
                    message.success("Columns updated")
                    getColumnConfig()
                    setCustomopen(false);
                }
            }
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const handleCheckboxChange = (fieldValue) => {
        const updatedCheckbox = checkbox.map((item) =>
            item.FieldValue === fieldValue ? { ...item, isChecked: !item.isChecked } : item
        );
        setCheckbox(updatedCheckbox);
    };
    async function GetAll() {
        try {
            const data = await getUserDataConfig(configId);
            const dbColumns = data.config || [];
            const defaultColumns = checkboxValues || [];
            const defaultKeys = new Set(defaultColumns.map(c => c.FieldValue));
            const dbKeys = new Set(dbColumns.map(c => c.FieldValue));
            const validDbColumns = dbColumns.filter(c => defaultKeys.has(c.FieldValue));
            const missingColumns = defaultColumns.filter(c => !dbKeys.has(c.FieldValue));
            setCheckbox([...validDbColumns, ...missingColumns])
        } catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (configId !== undefined && configId !== null && configId !== "") {
            GetAll()
        } else {
            setCheckbox(checkboxValues)
        }
    }, [configId])
    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const updatedItems = Array.from(checkbox);
        const [reorderedItem] = updatedItems.splice(result.source.index, 1);
        updatedItems.splice(result.destination.index, 0, reorderedItem);
        setCheckbox(updatedItems);
    };
    const renderView = ({ style, ...props }) => {
        // const customStyle = {
        //     marginRight: 'auto',
        // };
        // return <div {...props} style={{ ...style, ...customStyle }} />;
        return <div {...props} style={{ ...style }} />;
    };
    return (
        <>
            <Modal
                title="Manage Columns"
                open={customopen}
                onCancel={handleClose}
                maskClosable={false}
                footer={[
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        <Button
                            size="small"
                            className="gray-button"
                            onClick={handleClose}
                        >
                            <FeatherIcon icon="x" /> Cancel
                        </Button>
                        <Button size="small" className="button_colors" onClick={onSubmit} disabled={doubleClick} loading={doubleClick}>
                            {!doubleClick && <FeatherIcon icon="save" />}Save
                        </Button>
                    </div>
                ]}
                width={350}
            >
                <DragWrap>
                    <Form form={form} name="info" onFinish={onSubmit}>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <div className="sDash_kanban-board-list">
                                <div className="sDash_kanban-board-item">
                                    <Scrollbars
                                        autoHide
                                        autoHideTimeout={500}
                                        autoHideDuration={200}
                                        style={{ height: '100%' }} // make sure parent has fixed height
                                        renderView={renderView}
                                        className="sDash_kanban-board-item-scrolable"
                                    >
                                        <Droppable droppableId="droppable">
                                            {(provided) => (
                                                <div className="sDash_kanvan-task" {...provided.droppableProps} ref={provided.innerRef} >
                                                    {checkbox?.map((item, index) => (
                                                        <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                                                            {(provided) => (
                                                                <div
                                                                    className="sDash_kanvan-task__singleR"
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    ref={provided.innerRef}
                                                                >

                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                        <Checkbox
                                                                            checked={item.isChecked}
                                                                            onChange={() => handleCheckboxChange(item.FieldValue)}
                                                                        >
                                                                            {item.name}
                                                                        </Checkbox>
                                                                        <div>
                                                                            <FeatherIcon icon="menu" size={16} style={{ marginTop: 3, color: "#407fe9", cursor: "all-scroll" }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </Scrollbars>
                                </div>
                            </div>
                        </DragDropContext>
                    </Form>
                </DragWrap>
            </Modal>
        </>
    );
};

Popup.propTypes = {
    customopen: PropTypes.bool.isRequired,
    setCustomopen: PropTypes.func.isRequired,
    checkboxValues: PropTypes.object.isRequired,
    configId: PropTypes.number.isRequired,
    getColumnConfig: PropTypes.func.isRequired,
    pageName: PropTypes.string.isRequired,
};

export default Popup;
